module.exports = __webpack_public_path__ + "media/14.cb3f210f.mp3";